module.exports = __webpack_public_path__ + "static/media/CERTIFICADO DE ACCESIBILIDAD.d4307d8e.pdf";